import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);



// Update the ExamConfig interface to support both MCQ and Theory exams
export interface ExamConfig {
  examLevel: 'secondary' | 'university' | 'professional';
  questionCount: number;
  duration: number;
  
  secondary?: {
    class: string;
    subject: string;
    topics: string[];
    keywords: string[];
    examBody?: string[];
    questionTypes?: string[]; // For theory exams
  };
  
  university?: {
    fieldOfStudy: string;
    level: 'Undergraduate' | 'Postgraduate' | 'Researcher';
    course: string;
    topics: string[];
    keywords: string[];
    questionTypes?: string[]; // For theory exams
  };
  
  professional?: {
    fieldOfStudy: string;
    professionalBody: string;
    examName: string;
    expectedAreas: string[];
    keywords: string[];
    questionTypes?: string[]; // For theory exams
  };
}